var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#E8FAEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 14.5C17.5 16.43 19.07 18 21 18C22.93 18 24.5 16.43 24.5 14.5C24.5 12.57 22.93 11 21 11C19.07 11 17.5 12.57 17.5 14.5ZM19.5 14.5C19.5 13.67 20.17 13 21 13C21.83 13 22.5 13.67 22.5 14.5C22.5 15.33 21.83 16 21 16C20.17 16 19.5 15.33 19.5 14.5ZM21 19.75C23.34 19.75 28 20.92 28 23.25V25H14V23.25C14 20.92 18.66 19.75 21 19.75ZM21 21.75C22.79 21.75 24.82 22.42 25.66 23H16.34C17.18 22.42 19.21 21.75 21 21.75ZM13.96 19.81C12.8 20.65 12 21.77 12 23.25V25H8V23.25C8 21.23 11.5 20.08 13.96 19.81ZM11.5 14.5C11.5 16.43 13.07 18 15 18C15.54 18 16.04 17.87 16.5 17.65C15.87 16.76 15.5 15.67 15.5 14.5C15.5 13.33 15.87 12.24 16.5 11.35C16.04 11.13 15.54 11 15 11C13.07 11 11.5 12.57 11.5 14.5Z",
    fill: "#26CD58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.45fe84a70473199e0f0a6712d58b53f9.svg";
export { ForwardRef as ReactComponent };